<div class="dashboard-selector-container">
  @if (availableDashboards$ | async; as dashboards) {
  <div class="selector-wrapper">
    <mat-form-field appearance="outline">
      <mat-label>Vælg Dashboard</mat-label>
      <mat-select
        [value]="dashboards.currentDashboardId"
        (selectionChange)="onDashboardChange($event.value)"
      >
        @for (dashboard of dashboards.dashboards; track dashboard) {
        <mat-option [value]="dashboard.id">
          {{ dashboard.name }}
          @if (dashboard.isDefault) {
          <span class="default-indicator">(Standard)</span>
          } @if (dashboard.isSystemDefault) {
          <span class="system-indicator">(System)</span>
          }
        </mat-option>
        }
      </mat-select>
      <mat-hint>Vælg et dashboard fra listen eller opret et nyt</mat-hint>
    </mat-form-field>
    <div class="dashboard-actions">
      <button mat-button color="primary" (click)="createNewDashboard()">
        <mat-icon>add</mat-icon> Nyt Dashboard
      </button>
      @if (currentDashboard$ | async; as current) { @if (!current.isDefault) {
      <button mat-button color="accent" (click)="setAsDefault(current.id)">
        <mat-icon>star</mat-icon> Sæt som standard
      </button>
      } @if (!current.isSystemDefault) {
      <button mat-button color="warn" (click)="resetToDefault()">
        <mat-icon>refresh</mat-icon> Nulstil til system standard
      </button>
      } }
    </div>
  </div>
  }
</div>
